<template>
  <div>
    <div class="title-page flex justify-between items-center" style="padding: 1.3rem">
      <div class="flex items-center">
        <feather-icon icon="PackageIcon" svgClasses="h-4 w-4"></feather-icon>
        <h3 class="font-bold mr-3" style="display: inline-block; font-size: 1.125rem">
          {{ $t("internationalShipments") }}
        </h3>
      </div>
      <v-select
        v-model="statusFilter"
        :options="statusOptions"
        :reduce="(option) => option.value"
        :clearable="true"
        :placeholder="$t('statusOfOrder')"
        style="min-width: 220px"
      />
    </div>
    <div class="line"></div>

    <div v-if="loading" class="p-6 loading-table">
      <spinner-color />
    </div>

    <div v-else-if="error_msg" style="padding: 1.3rem">
      <vs-alert color="danger" icon="new_releases" :active="true">
        <span>{{ error_msg }}</span>
      </vs-alert>
    </div>

    <div v-else style="padding: 1.3rem">
      <div class="intl-shipments-table-scroll">
        <vs-table :data="shipments" noDataText="">
          <template slot="thead">
            <vs-th>{{ $t("code") }}</vs-th>
            <vs-th>{{ $t("statusOfOrder") }}</vs-th>
            <vs-th>{{ $t("cartonsCount") }}</vs-th>
            <vs-th>{{ $t("totalWeightKg") }}</vs-th>
            <vs-th>{{ $t("totalCostUsd") }}</vs-th>
            <vs-th>{{ $t("dateOfRegistration") }}</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">
              <vs-td>
                <router-link :to="'/InternationalShipmentDetails/' + tr.id" class="font-medium code">
                  {{ tr.code }}
                </router-link>
              </vs-td>
              <vs-td>{{ tr.status.label }}</vs-td>
              <vs-td>{{ tr.cartons_count }}</vs-td>
              <vs-td>{{ tr.total_weight_kg }}</vs-td>
              <vs-td>{{ tr.total_cost_usd != null ? tr.total_cost_usd + ' $' : '-' }}</vs-td>
              <vs-td>{{ formatDate(tr.created_at) }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <empty-data v-if="!shipments.length" />

      <div v-if="totalPages > 1" class="flex justify-center mt-4">
        <vs-pagination :total="totalPages" v-model="page" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";
import EmptyData from "@/views/components/table-components/EmptyData.vue";

export default {
  components: {
    SpinnerColor,
    EmptyData,
    vSelect,
  },
  data() {
    return {
      loading: false,
      page: 1,
      statusFilter: null,
      statusOptions: [
        { value: "draft", label: this.$t("intlStatusDraft") },
        { value: "approved", label: this.$t("intlStatusApproved") },
        { value: "in_transit", label: this.$t("intlStatusInTransit") },
        { value: "arrived_tripoli", label: this.$t("intlStatusArrivedTripoli") },
        { value: "received_tripoli", label: this.$t("intlStatusReceivedTripoli") },
        { value: "delivered", label: this.$t("intlStatusDelivered") },
        { value: "converted_to_local", label: this.$t("intlStatusConvertedToLocal") },
        { value: "cancelled", label: this.$t("intlStatusCancelled") },
      ],
    };
  },
  computed: {
    ...mapGetters("internationalShipping", ["shipments", "shipments_pagination", "error_msg"]),
    totalPages() {
      return this.shipments_pagination ? this.shipments_pagination.last_page : 1;
    },
  },
  watch: {
    page() {
      this.fetchList();
    },
    statusFilter() {
      this.page = 1;
      this.fetchList();
    },
  },
  methods: {
    ...mapActions("internationalShipping", ["fetchShipments"]),
    async fetchList() {
      this.loading = true;
      await this.fetchShipments({ page: this.page, perPage: 10, status: this.statusFilter });
      this.loading = false;
    },
    formatDate(value) {
      return new Date(value).toLocaleDateString("en-LY", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Africa/Tripoli",
      });
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";

.intl-shipments-table-scroll {
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: auto;

  ::v-deep thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #fff;
  }
}
</style>
